<template>
	<v-dialog
		:value="$wait.is('form customer')"
		persistent
		max-width="1200px"
		transition="dialog-bottom-transition"
		scrollable
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				color="primary"
				dark
				@click="openCustomerForm"
				class="mt-2"
				v-bind="attrs"
				v-on="on"
				outlined
			>
				{{ $t("label.create_customer") }}
			</v-btn>
		</template>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-card>
				<v-card-title primary-title>
					{{ $t("title.create_customer") }}
				</v-card-title>
				<v-spacer></v-spacer>
				<v-card-text>
					<v-container grid-list-md class="container--box">
						<form-customer v-model="customer"></form-customer>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="closeCustomer()">
						<v-icon left>mdi-close</v-icon>
						{{ $t("Close") }}
					</v-btn>
					<v-btn
						color="primary"
						@click.native="submitCustomer()"
						:loading="customer.processing"
						:disabled="invalid"
					>
						<v-icon left>mdi-content-save</v-icon>
						{{ $t("Save") }}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</ValidationObserver>
	</v-dialog>
</template>

<script>
export default {
	data() {
		return {
			customer: this.$inertia.form({
				image: {},
				first_name: null,
				last_name: null,
				female: null,
				male: null,
				birthday: null,
				phone: null,
				email: null,
				company_name: null,
				address: null,
				city: null,
				telegram: null,
				language: null,
				title: null,
				active: true,
				response: "json",
			}),
		};
	},

	methods: {
		openCustomerForm() {
			try {
				this.customer = this.$inertia.form({
					image: {},
					first_name: null,
					last_name: null,
					female: null,
					male: null,
					birthday: null,
					phone: null,
					email: null,
					company_name: null,
					address: null,
					city: null,
					telegram: null,
					language: null,
					title: null,
					active: true,
					response: "json",
				});

				this.$wait.start("form customer");
			} catch (error) {
				this.$toast.error(error.message);
			}
		},

		closeCustomer() {
			this.$wait.end("form customer");
		},

		submitCustomer() {
			if (this.$route().current("tenant.*")) {
				this.customer.post(
					this.$route("tenant.customers.store", {
						tenant: this.$page.props.tenant.id,
					}),
					{
						onSuccess: () => this.onSuccess(),
						preserveScroll: true,
						preserveState: true,
					}
				);
			} else if (this.$route().current("central.*")) {
				this.customer.post(this.$route("central.customers.store"), {
					onSuccess: () => this.$wait.end("form customer"),
					preserveScroll: true,
					preserveState: true,
				});
			}
		},

		onSuccess() {
			this.$wait.end("form customer");
			this.$emit("onSuccess");
		},
	},
};
</script>